export default __webpack_public_path__ + "static/media/bbDrop.7fc40c99.svg";